import React, { useState } from "react";
import PropTypes from "prop-types";
import { useArena } from "core/components/ArenaProvider";
import ContentHelmet from "arena/components/ContentHelmet";
import ShortyVirtualFeed from "./ShortyVirtualFeed";

export default function Shorty({ params: { contentId } }) {
  const arena = useArena();
  const [helmetContent, setHelmetContent] = useState(null);

  return (
    <>
      <ContentHelmet arena={arena} content={helmetContent} />
      <ShortyVirtualFeed
        initialContentId={contentId}
        onHelmetContentChange={setHelmetContent}
      />
    </>
  );
}

Shorty.propTypes = {
  params: PropTypes.shape({
    contentId: PropTypes.string.isRequired,
  }),
};
